<script setup lang="ts">
import { AlertDialogDescription } from 'reka-ui'
import { cn } from '@/utils/shadcn'

const props = defineProps<{ class?: unknown }>()
</script>

<template>
    <AlertDialogDescription :class="cn('text-sm text-muted-foreground leading-snug', props.class)">
        <slot />
    </AlertDialogDescription>
</template>
